/**
 * Sort function for items with a name property
 * @param a First item to compare
 * @param b Second item to compare
 * @returns Negative if a comes before b, positive if b comes before a, 0 if equal
 */
export function sortByName<T extends { name: string }>(a: T, b: T): number {
	return a.name.localeCompare(b.name);
}

/** Sort by capital `Name` field. */
export function sortByNameCapital<T extends { Name?: string }>(a: T, b: T): number {
	return (a.Name ?? "").localeCompare(b.Name ?? "");
}
